import React from "react";
import classNames from "classnames";
import { InputNumber as InputNumberAntd } from "antd";
import {hasBeenFilled} from "../../../helpers/dynamicFormHelper";
import {getStepPrecision} from "../../../helpers/utilsHelper";

interface PropsType {
  className: string,
  value: any,
  step: any,
  min: any,
  max: any,
  placeholder: any,
  name: any,
  disabled: any,
  onChange: any,
  onClear?: any
}

const InputNumber = (props: PropsType) => {
  const {
    className,
    value,
    step,
    min,
    max,
    placeholder,
    name,
    disabled,
    onChange,
    onClear
  } = props;

  const isInputDisabled = disabled && hasBeenFilled(value);
  const isClearable = !disabled && hasBeenFilled(value);

  return (
    <div className="input-number-container">
      <InputNumberAntd
        className={className}
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        name={name}
        type="number"
        precision={getStepPrecision(step)}
        onChange={(numericValue) => {
          let newValue = numericValue;
          if (hasBeenFilled(newValue)) {
            // @ts-ignore
            if (min >= numericValue) {
              newValue = min;
            }
            // @ts-ignore
            if (max <= numericValue) {
              newValue = max;
            }
          }
          onChange(newValue);
        }}
        value={value}
        disabled={isInputDisabled}
      />
      <div
        className={classNames("clear-icon-container", {
          "d-none": !isClearable
        })}
        role="button"
        aria-hidden="true"
        onClick={() => {
          if (onClear) onClear()
        }}
      >
        <svg><use xlinkHref="#close-icon" /></svg>
      </div>
    </div>
  );
};

export default InputNumber;
